import { useState } from "react";
import { Play } from "lucide-react";

type Props = {
  /** Vimeo-id, t.ex. "1043905042". */
  videoId: string;
  title: string;
  /** Text på uppspelningsknappen. */
  playLabel: string;
};

/**
 * Lättviktig videobädd: laddar Vimeo-spelaren först när besökaren klickar,
 * så sidans laddtid inte påverkas.
 */
export function VideoEmbed({ videoId, title, playLabel }: Props) {
  const [active, setActive] = useState(false);

  return (
    <div className="relative aspect-video w-full overflow-hidden rounded-xl border border-border bg-secondary/30 shadow-soft">
      {active ? (
        <iframe
          src={`https://player.vimeo.com/video/${videoId}?autoplay=1&badge=0&autopause=0&player_id=0&app_id=58479`}
          title={title}
          allow="autoplay; fullscreen; picture-in-picture"
          allowFullScreen
          loading="lazy"
          className="absolute inset-0 size-full"
        />
      ) : (
        <button
          type="button"
          onClick={() => setActive(true)}
          className="group absolute inset-0 flex size-full flex-col items-center justify-center gap-3 bg-gradient-to-b from-secondary/20 to-primary/10 transition-colors hover:bg-primary/5"
        >
          <span className="flex size-16 items-center justify-center rounded-full border-2 border-primary text-primary transition-transform group-hover:scale-105">
            <Play className="size-7 translate-x-0.5" />
          </span>
          <span className="text-sm font-medium text-foreground">{playLabel}</span>
        </button>
      )}
    </div>
  );
}
